import z from "zod";
import { options } from "../constants.schema";

const optionsMulti = {
  first_id: z.string(),
  name_first: z.string(),
  second_id: z.string(),
  name_second: z.string(),
  category_id: z.string().nullable().optional().or(z.literal("")),
};

export const specialtiesAndSkillSchema = z.object({
  level_english: z.object(options).optional(),
  languages: z.array(z.object(optionsMulti)).optional(),
  categories: z.array(z.object(options)).optional(),
  skills: z.array(z.object(optionsMulti)).optional(),
  specialties: z.array(z.object(optionsMulti)).optional(),
});

export type SpecialtiesAndSkillType = z.infer<typeof specialtiesAndSkillSchema>;
